import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const DUCK_NOT_FOUND_KEY = 'duckNotFoundReducer';

const LOAD_DUCK_NOT_FOUND = 'LOAD_DUCK_NOT_FOUND';
const SET_HOME_PAGE_ERROR = 'SET_HOME_PAGE_ERROR';

/* REDUCER */
let defaultState = fromJS({
  pageContent: {
    text: null,
    helmetData: null,
  },
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_DUCK_NOT_FOUND: {
      return state.merge({ pageContent: action.payload, errorMessage: '' });
    }
    case SET_HOME_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */

/* SELECTORS */
export const selectNotFoundData = (state) => {
  return valIn(state[DUCK_NOT_FOUND_KEY], 'pageContent');
};

export const selectText = (state) => {
  return valIn(selectNotFoundData(state), 'text');
};

export const selectHelmetData = (state) => {
  return valIn(selectNotFoundData(state), 'helmetData');
};
